import { ColumnsType } from 'antd/lib/table';
import Flag from 'react-flagpack';

import { ErrorBoundary, StatusTag } from '../../../../components/index';
import { createDateStringPtBr } from '../../../../utils/utils';

export type ColumnsFilterType = {
  text: string;
  value: string;
};

export const omissionTypeLabels: Record<string, string> = {
  OMISSION: 'Omissão',
  EVASION: 'Evasão',
};

export function OmissionReportTableColumns(): ColumnsType<Record<string, any>> {
  return [
    {
      title: 'Escala',
      dataIndex: 'code',
      render: (value) => {
        return <div>{value}</div>;
      },
    },
    {
      title: 'Tipo',
      dataIndex: 'omission_type',
      render: (value) => {
        if (!value) return <div />;
        return (
          <StatusTag>
            <span className={value === 'EVASION' ? 'red' : 'orange'}>
              {omissionTypeLabels[value] || value}
            </span>
          </StatusTag>
        );
      },
    },
    {
      title: 'Embarcação',
      dataIndex: 'vessel_name',
      render: (value, record) => {
        return (
          <div style={{ display: 'flex', gap: '4px' }}>
            <div style={{ width: '20px' }}>
              {record.vessel_flag && (
                <ErrorBoundary replace="">
                  <Flag code={record.vessel_flag} size="m" />
                </ErrorBoundary>
              )}
            </div>
            <span
              style={{
                textTransform: 'capitalize',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
              }}
            >
              {value?.toLowerCase() || ''}
            </span>
          </div>
        );
      },
    },
    {
      title: 'IMO',
      dataIndex: 'vessel_imo',
      render: (value) => {
        return <div>{value}</div>;
      },
    },
    {
      title: 'DUV',
      dataIndex: 'duv',
      render: (value) => {
        return <div>{value}</div>;
      },
    },
    {
      title: 'Berço',
      dataIndex: 'docking_place_name',
      render: (value) => {
        return <div>{value}</div>;
      },
    },
    {
      title: 'Agente de navegação',
      dataIndex: 'shipping_agency_name',
      render: (value) => {
        return <div>{value}</div>;
      },
    },
    {
      title: 'Data da omissão',
      dataIndex: 'omission_date',
      render: (value) => {
        return <div>{createDateStringPtBr(value)}</div>;
      },
    },
    {
      title: 'Motivo',
      dataIndex: 'omission_motivation',
      render: (value) => {
        return <div>{value}</div>;
      },
    },
  ];
}
